import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import ReactModal from 'react-modal';

export default function GalleryBlockModal({ image, onClick, toggle }) {
  return (
    <ReactModal
      isOpen={toggle}
      onRequestClose={onClick}
      shouldCloseOnEsc
      shouldCloseOnOverlayClick
      shouldFocusAfterRender
      className="fixed top-1/2 left-1/2 right-auto bottom-auto -translate-y-1/2 -translate-x-1/2
        w-[80vw] lg:w-full !max-w-[80vw] bg-white flex flex-col items-center
        justify-start lg:rounded-[0.25rem] outline-none border-[transparent] border-0
        appearance-none h-auto"
      overlayClassName="fixed top-0 left-0 z-[100] inset-0 bg-black bg-opacity-80 outline-none
        border-[transparent] border-0 appearance-none"
    >
      <div className="bg-white md:w-[80vw] md:h-[80vh]">
        <LazyLoadImage
          src={image}
          alt="dubai sports world"
          className="w-full h-full object-cover"
        />
      </div>
    </ReactModal>
  );
}
